import { parseApiDate } from "~/utils";

export const state = () => ({
    articles: [],
    article: null,
    loaded: false, // True when articles index and categories have been loaded
});

export const mutations = {
    setArticles(state, articles) {
        state.articles = articles;
    },
    setArticle(state, article) {
        state.article = article;
    },
};

export const actions = {
    async fetchArticles(context) {
        try {
            let { data } = await this.$adminApi.get("/insight/articles");
            context.commit("setArticles", data.articles);
        } catch (error) {
            console.log("Failed to fetch insight articles: " + error);
            throw error;
        }
    },
    async fetchArticle(context, payload) {
        try {
            let { data } = await this.$adminApi.get("/insight/article/" + payload.year + "/" + payload.slug);
            context.commit("setArticle", data.article);
        } catch (error) {
            console.log("Failed to fetch insight articles: " + error);
            throw error;
        }
    },
};

export const getters = {
    getArticles(state) {
        return state.articles;
    },
    getFeaturedArticles(state) {
        return state.articles.filter((article) => article.featured);
    },
    getArticle(state) {
        return state.article;
    },
    getCategories(state) {
        return Object.values(
            state.articles.reduce((categories, article) => {
                if (!categories[article.category.id]) categories[article.category.id] = article.category;
                return categories;
            }, {})
        );
    },
};
